import {Component} from '@angular/core';
import {TranslatePipe} from "ng2-translate/ng2-translate";


@Component({
  templateUrl: 'build/pages/contact/contact.html',
  pipes: [TranslatePipe]
})
export class ContactPage {
  constructor() {

  }
}
